
import workPostQuery from "~/apollo/queries/work/post";
import workPostsByTagQuery from "~/apollo/queries/work/postsByTag";
import locomotiveScrollMixin from "@/mixins/locomotiveScrollMixin";
import previewModeMixin from "@/mixins/previewModeMixin";
import fetchPostMixin from "@/mixins/fetchPostMixin";
import photoSwipeMixin from '@/mixins/photoSwipe';
import photoSwipeImgPathsMixin from '@/mixins/photoSwipeImgPaths';
import animateInMixin from '@/mixins/animateInMixin';
import {mdToHtml} from '~/utils/markdown'

export default {
  name: 'WorkPostSlug',
  colorMode: 'light',
  mixins: [locomotiveScrollMixin, previewModeMixin, fetchPostMixin, photoSwipeMixin, photoSwipeImgPathsMixin, animateInMixin],
  computed: {
    imageAttributes() {
      if (this.workPost
        && this.workPost.attributes
        && this.workPost.attributes.thumbnails
        && this.workPost.attributes.thumbnails.data
        && this.workPost.attributes.thumbnails.data[0]) {
        return this.getAttribute(this.workPost.attributes.thumbnails.data[0], 'attributes');
      } else {
        return null;
      }
    },
  },
  data() {
    return {
      galleryID: "#project-gallery",
      projectDetailsVisible: false,
      workPost: null,
      relatedPosts: null,
      photoSwipeActive: true,
    };
  },
  watch: {
    projectDetailsVisible(newValue) {
      if (newValue) {
        this.animateProjectDetails();
      }
    }
  },
  created() {
    const preview = this.$route.query.preview;

    if (preview) {
      // Set color as it doesn't automatically set after redirect
      this.$colorMode.preference = 'dark';

      if (!this.workPost) {
        this.fetchPost('workPosts', workPostQuery).then(workPostData => {
          this.workPost = workPostData;
          this.fetchRelatedPosts(workPostData.attributes.tags.data.map(tag => tag.attributes.name)).then(relatedPostsData => {
            this.relatedPosts = relatedPostsData;
            this.$nextTick(() => {
              this.previewMode = true;
            });
          });
        });
      }
    }
  },
  async asyncData({app, route, store}) {
    const previewMode = store.state.previewMode;

    // console.log('previewMode', previewMode);
    if (previewMode) {
      await app.apolloProvider.defaultClient.resetStore();
    }

    // Fetch workPost data
    const workPostResponse = await app.apolloProvider.defaultClient.query({
      query: workPostQuery,
      variables: {
        slug: route.params.slug,
        locale: app.i18n.locale,
      },
    });

    const workPostData = workPostResponse.data.workPosts.data[0];

    // Process Markdown for each section
    workPostData.attributes.sections = await mdToHtml(workPostData);

    // Fetch relatedPosts data
    let relatedPostsResponse = await app.apolloProvider.defaultClient.query({
      query: workPostsByTagQuery,
      variables: {
        tagNames: workPostData.attributes.tags.data.map(tag => tag.attributes.name),
        locale: app.i18n.locale,
      },
    });

    const relatedPostsData = relatedPostsResponse.data.workPosts.data;

    // Set route parameters for localization
    app.store.dispatch(
      "i18n/setRouteParams",
      Object.fromEntries(
        workPostData.attributes.localizations.data.map((el) => [
          el.attributes.locale,
          {slug: el.attributes.slug},
        ])
      )
    );

    return {
      workPost: workPostData,
      relatedPosts: relatedPostsData,
      previewMode
    };
  },
  methods: {
    async fetchRelatedPosts(tagNames) {
      const relatedPostsResponse = await this.$apolloProvider.defaultClient.query({
        query: workPostsByTagQuery,
        variables: {
          tagNames,
          locale: this.$i18n.locale,
        },
      });

      return relatedPostsResponse.data.workPosts.data;
    },
    animateProjectDetails() {
      const tl = this.$gsap.timeline();

      tl.from(this.$refs.projectDetails.querySelectorAll(".hidden .text-anim"), {
        duration: 0.5,
        y: -20,
        opacity: 0,
        stagger: 0.1,
        ease: "power3.out",
      });
    }
  },
}
